import * as React from 'react';
import { TextField, PropTypes } from '@mui/material';

interface RenderInputTypeProps {
    error?: boolean;
    fullWidth?: boolean;
    required?: boolean;
    inputProps?: any
    InputProps?: any;
    InputLabelProps?: any;
    label?: React.ReactNode;
    margin?: 'dense' | 'normal' | 'none';
    key?: string;
    ref?: React.Ref<any> | React.RefObject<any>;
}

export const RenderInput: React.FC<RenderInputTypeProps> = (props) => {
    const { InputProps, inputProps, margin, required, key, error, ref, ...other } = props;

    return (
        <TextField
            key={key}
            error={error}
            inputProps={inputProps}
            margin={margin}
            required={required}
            InputProps={{
                inputRef: ref,
                ...InputProps,
            }}
            {...other}
        />
    );
}
